import { createSlice } from "@reduxjs/toolkit";

const emptySeries = [0, 0, 0, 0];

const initialState = {
  loading: false,
  error: null,
  morning: {
    moodLevels: emptySeries,
    sleepQualityLevels: emptySeries,
    stressLevels: emptySeries,
  },
  night: {
    mindsetLevels: emptySeries,
    productivityLevels: emptySeries,
    creativityLevels: emptySeries,
  },
};

const wellnessSlice = createSlice({
  name: "wellness",
  initialState,
  reducers: {
    setWellnessLoading(state, action) {
      state.loading = action.payload;
    },
    setWellnessError(state, action) {
      state.error = action.payload || null;
    },
    setWellnessData(state, action) {
      const { morning, night } = action.payload || {};
      if (morning) state.morning = { ...state.morning, ...morning };
      if (night) state.night = { ...state.night, ...night };
    },
    resetWellness(state) {
      state.loading = false;
      state.error = null;
      state.morning = { ...initialState.morning };
      state.night = { ...initialState.night };
    },
  },
});

export const {
  setWellnessLoading,
  setWellnessError,
  setWellnessData,
  resetWellness,
} = wellnessSlice.actions;

export default wellnessSlice.reducer;

export const selectWellness = (state) => state.wellness;
export const selectWellnessMorning = (state) => state.wellness.morning;
export const selectWellnessNight = (state) => state.wellness.night;
